import React from "react";
import { Card, CardHeader, Row, Col, CardBody } from "shards-react";
import { Link } from "react-router-dom";
import { TiEdit,TiDeleteOutline, TiEyeOutline } from "react-icons/ti";
import ProjectDataService from "../../services/project.service";
import { FcPlus } from "react-icons/fc";
import moment from "moment";
import "react-toastify/dist/ReactToastify.css";
import ReactTooltip from "react-tooltip";
import { actions as AppActions } from "../../_stores/app.store";
import CustomPagination from "../common/CustomPagination";
import authStore from "../../_stores/auth.store";

class ViewProjectsSuperAdmin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      projectsList: [],
      projectList_paged: [],
    };
    this.setPagedProjectList = this.setPagedProjectList.bind(this);
    this.deleteProject = this.deleteProject.bind(this);
  }

  componentDidMount() {
    this.retrieveProjectStructure();
  }

  componentDidUpdate(prevProps) {
  }

  retrieveProjectStructure() {
    AppActions.setLoading(true);
    ProjectDataService.getAll().then((response) => {
      AppActions.setLoading(false);
      this.setState({
        projectsList: response.data.data,
      });
    });
  }

  deleteProject(id){
    AppActions.setLoading(true);
    ProjectDataService.delete(id).then((response) => {
      this.retrieveProjectStructure();
      this.props.notify("success", "Project Deleted");
    })
    .catch((error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      this.setState({
        message: message,
      });
      this.props.notify("error", message);
      AppActions.setLoading(false);
    });
  }

  setPagedProjectList(prodList) {
    this.setState({ projectList_paged: prodList });
  }

  render() {
    const { projectsList, projectList_paged } = this.state;

    return (
      <>
        <Row>
          <Col>
            <Card small className="mb-4">
              <CardHeader className="border-bottom">
                <h6 className="m-0">
                  Projects List
                  <Link className="btn btn-primary ml-4" to={"/create-project-superadmin"}>
                    {" "}
                    <FcPlus /> Create New Project
                  </Link>
                </h6>
              </CardHeader>
              <CardBody className="p-0 pb-3">
                <div className="table-responsive variant-01">
                  <table className="table mb-0 border-bottom" size="sm">
                    <thead className="bg-light">
                      <tr>
                        <th scope="col" className="border-0">
                          Project Name
                        </th>
                        <th scope="col" className="border-0">
                          Data Send to Database
                        </th>
                        <th scope="col" className="border-0">
                          Data Send to API
                        </th>
                        {/*<th scope="col" className="border-0">
                        </th>
                         <th scope="col" className="border-0">
                          Server Path
                        </th>
                        <th scope="col" className="border-0">
                          Server User Name
                        </th>
                        <th scope="col" className="border-0">
                          Server Port Number
                        </th>
                        <th scope="col" className="border-0">
                          Server Folder Path
                        </th> */}
                        <th scope="col" className="border-0">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {projectList_paged && projectList_paged.length
                        ? projectList_paged.map((item, index) => {
                            return (
                              <tr key={index + 1}>
                                <td>{item.projectName}</td>
                                <td>{item.dataSendToDatabase ? "Yes" : "No"}</td>
                                <td>{item.dataSendToApi ? "Yes" : "No"}</td>
                                {/*<td>{moment(new Date(item.startDate)).format("Do MMM YYYY")}</td>
                                <td>{item.countryName}</td>
                                <td>{item.asset}</td>
                                <td>{item.serverPath}</td>
                                <td>{item.serverUserName}</td>
                                <td>{item.serverPortNumber}</td>
                                <td>{item.serverFolderPath}</td> */}
                                <td>
                                  <Link
                                    className="text-primary"
                                    data-tip
                                    data-for="detailTip"
                                    to={"/project-superadmin/" + item.id}
                                  >
                                    <TiEyeOutline />
                                  </Link>
                                  <ReactTooltip id="detailTip" place="top" effect="solid">
                                    Detail
                                  </ReactTooltip>
                                  <Link
                                    className="text-success"
                                    data-tip
                                    data-for="editTip"
                                    to={"/project-superadmin/" + item.id + "/edit"}
                                  >
                                    <TiEdit />
                                  </Link>
                                  <ReactTooltip id="editTip" place="top" effect="solid">
                                    Edit
                                  </ReactTooltip>
                                  {authStore.getState().auth_reducer.user.role === "superadmin" && (
                                    <span className="text-danger cursor-pointer" title="delete" onClick={() => this.deleteProject(item.id)}><TiDeleteOutline size="20" /></span>
                                  )}
                                </td>
                              </tr>
                            );
                          })
                        : null}
                    </tbody>
                  </table>
                </div>
                <div className="flx-content-right mt-3">
                  <CustomPagination data={projectsList} setData={this.setPagedProjectList} pageSize={5} />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}

export default ViewProjectsSuperAdmin;
